export default __webpack_public_path__ + "static/media/2.39351bad.mp4";